import { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../../../../../layoutcontainers/DashboardLayout";
import { Box, Grid2 } from "@mui/material";
import VehicleDetails from "./components/VehicleDetails";
import IDVDetails from "./components/IDVDetails";
import QutationCard from "./components/QutationCard";
import AddonsandAdditional from "./components/AddonsAndAdditional";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import { ShareCard } from "./components/QutationCard/ShareCard";
import RenewBuyPDF from "../pdf/renewby";
import html2pdf from "html2pdf.js";

const bankData = [
  {
    name: "ICICI Prudential",
    logo: "https://th.bing.com/th/id/OIP.080kVD04xJK9P2sYrT2vXwHaEK?rs=1&pid=ImgDetMain&cb=idpwebpc2",
    idvRange: "₹1,233,098 - 1,234,543",
    premium: "₹1,34,765",
    price: "15,780",
    priceColor: "#F39C12",
    addons: [
      // Always present
      "PA Cover for Owner-Driver",
      "Zero Depreciation",
      "Key Replacement",
      "Return To Invoice",
      "Roadside Assistance",
      "Consumable Cover",
      "Engine Protector",
      "Non Electrical Accessories",
      "PA for Paid Driver",
      "Unnamed Passenger Cover",
      "Electrical Accessories",
      "Legal Liability to Paid Driver",
      "Legal Liability to Employee",
      "Anti-theft Device",
      "Automobile Membership",
      // Shuffled
      "NCB Protector",
      "Towing Cover",
      "Loss of Personal Belongings",
      "External CNG/LPG",
      "Geographical Extension",
    ],
  },
  {
    name: "HDFC Ergo",
    logo: "https://global-uploads.webflow.com/6145f7156a1337613524d548/6329b1568d088fd54be731c4_logo__HDFC%20.png",
    idvRange: "₹1,100,000 - 1,200,000",
    premium: "₹1,10,000",
    price: "17,679",
    priceColor: "#3498DB",
    addons: [
      // Always present
      "PA Cover for Owner-Driver",
      "Zero Depreciation",
      "Key Replacement",
      "Return To Invoice",
      "Roadside Assistance",
      "Consumable Cover",
      "Engine Protector",
      "Non Electrical Accessories",
      "PA for Paid Driver",
      "Unnamed Passenger Cover",
      "Electrical Accessories",
      "Legal Liability to Paid Driver",
      "Legal Liability to Employee",
      "Anti-theft Device",
      "Automobile Membership",
      // Shuffled
      "Daily Cash Allowance",
      "Loss of Personal Belongings",
      "Geographical Extension",
      "Voluntary Deductible",
      "NCB Protector",
    ],
  },
  {
    name: "Bajaj Allianz",
    logo: "https://dw8hn2nzcjgu6.cloudfront.net/wp-content/uploads/2021/06/bajaj-Allianz.jpg",
    idvRange: "₹1,050,000 - 1,150,000",
    premium: "₹1,05,000",
    price: "21,565",
    priceColor: "#2ECC71",
    addons: [
      // Always present
      "PA Cover for Owner-Driver",
      "Zero Depreciation",
      "Key Replacement",
      "Return To Invoice",
      "Roadside Assistance",
      "Consumable Cover",
      "Engine Protector",
      "Non Electrical Accessories",
      "PA for Paid Driver",
      "Unnamed Passenger Cover",
      "Electrical Accessories",
      "Legal Liability to Paid Driver",
      "Legal Liability to Employee",
      "Anti-theft Device",
      "Automobile Membership",
      // Shuffled
      "Tyre Protector",
      "Daily Cash Allowance",
      "Geographical Extension",
      "External CNG/LPG",
      "Voluntary Deductible",
    ],
  },
];

const PlanProposalFlow = () => {
  const pdfRef = useRef();
  const minValue = 80100;
  const maxValue = 128789;
  const getPremiumValue = (str) => Number(str.replace(/[₹,]/g, ""));
  const parsePrice = (str) => parseInt(str.replace(/,/g, ""));
  const formatPrice = (num) => num.toLocaleString("en-IN");

  const [addonsValue, setAddonsValue] = useState(false);
  const [idvValue, setIdvValue] = useState(minValue);
  const [paCoverChecked, setPaCoverChecked] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState({});
  const [selectedCovers, setSelectedCovers] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedDiscounts, setSelectedDiscounts] = useState({});
  const [filter, setFilter] = useState(false);
  const [open, setOpen] = useState(false);
  const isFirstRender = useRef(true);
  const [allData, setAlldata] = useState(() => {
    const storedData = localStorage.getItem("allData");
    return storedData ? JSON.parse(storedData) : bankData;
  });
  const [selectedValue, setSelectedValue] = useState([]);

  const addonPrices = {
    "Zero Depreciation": 3250,
    "Key Replacement": 470,
    "Return To Invoice": 2500,
    "Roadside Assistance": 258,
    "Consumable Cover": 370,
    "Engine Protector": 680,
    "Daily Cash Allowance": 300,
    "Loss of Personal Belongings": 250,
    "Tyre Protector": 750,
    "NCB Protector": 1300,
    "Towing Cover": 200,
  };

  localStorage.setItem("addonPrices", JSON.stringify(addonPrices));

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const updatedData = allData.map((bank) => {
      const originalPremium = parsePremium(bank.premium);
      const updatedPremium = originalPremium + idvValue;
      return {
        ...bank,
        premium: formatPremium(updatedPremium),
      };
    });
    setAlldata(updatedData);
  }, [idvValue]);
  useEffect(() => {
    localStorage.setItem("allData", JSON.stringify(allData));
  }, [allData]);

  const handleClearAddons = async () => {
    setPaCoverChecked(false);
    setSelectedAddons({});
    setSelectedCovers({});
    setSelectedOptions({});
    setSelectedDiscounts({});
  };

  const sortByPremiumAsc = () => {
    const sorted = allData
      .map((item) => ({ ...item })) // Deep copy
      .sort((a, b) => getPremiumValue(a.premium) - getPremiumValue(b.premium));

    setAlldata(sorted); // Update state
  };

  const sortByPremiumDesc = () => {
    const sorted = allData
      .map((item) => ({ ...item }))
      .sort((a, b) => getPremiumValue(b.premium) - getPremiumValue(a.premium));

    setAlldata(sorted); // Update state
  };

  const filterOnCLick = () => {
    setFilter(!filter);
    if (filter) {
      sortByPremiumDesc();
    } else {
      sortByPremiumAsc();
    }
  };
  const onCloseHandel = () => {
    setOpen(false);
  };
  const onOpenHandel = () => {
    setOpen(true);
  };
  const parsePremium = (premiumStr) => {
    return parseInt(premiumStr.replace(/[₹,]/g, ""));
  };

  // Helper: Format number → "₹1,34,765"
  const formatPremium = (value) => {
    return "₹" + value.toLocaleString("en-IN");
  };

  const handleUpdate = async () => {
    const addonData = {
      paCoverChecked: paCoverChecked,
      selectedAddons: selectedAddons,
      selectedCovers: selectedCovers,
      selectedOptions: selectedOptions,
      selectedDiscounts: selectedDiscounts,
    };
    // Step 1: Sum all values in selectedValue
    const totalAddonPrice = selectedValue.reduce((sum, obj) => {
      const value = Object.values(obj)[0]; // get value from { "Key": value }
      return sum + (typeof value === "number" ? value : 0);
    }, 0);

    // Step 2: Add totalAddonPrice to each bank's price
    const updatedData = allData.map((bank) => {
      const basePrice = parsePrice(bank.price);
      const newPrice = basePrice + totalAddonPrice;

      return {
        ...bank,
        price: formatPrice(newPrice),
      };
    });

    setAlldata(updatedData);
    localStorage.setItem("addonData", JSON.stringify(addonData));
    setAddonsValue(true);
  };

  const downloadPDF = () => {
    const element = pdfRef.current;
    const opt = {
      margin: 10,
      filename: "Quotes_Policy.pdf",
      image: { type: "jpeg", quality: 0.9 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: "pt", format: "letter", orientation: "portrait" },
    };

    html2pdf().from(element).set(opt).save();
  };
  return (
    <DashboardLayout>
      <Grid2 container direction="row" spacing={1}>
        <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
          <Grid2 container direction="column" spacing={2}>
            <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
              <VehicleDetails />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
              <IDVDetails
                idvValue={idvValue}
                setIdvValue={setIdvValue}
                minValue={minValue}
                maxValue={maxValue}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
              <AddonsandAdditional
                selectedValue={selectedValue}
                setSelectedValue={setSelectedValue}
                paCoverChecked={paCoverChecked}
                setPaCoverChecked={setPaCoverChecked}
                selectedAddons={selectedAddons}
                setSelectedAddons={setSelectedAddons}
                selectedCovers={selectedCovers}
                setSelectedCovers={setSelectedCovers}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
                selectedDiscounts={selectedDiscounts}
                setSelectedDiscounts={setSelectedDiscounts}
                handleUpdate={handleUpdate}
                handleClearAddons={handleClearAddons}
              />
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 8, md: 8 }} sx={{ px: 1 }}>
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "10px",
            }}
          >
            <Box>
              {filter ? (
                <FilterListOffIcon onClick={() => filterOnCLick()} />
              ) : (
                <FilterListIcon onClick={() => filterOnCLick()} />
              )}
            </Box>
            <Box sx={{ margin: "0px 20px" }}>
              <button
                className="bg-color"
                style={{
                  border: "none",
                  padding: "8px 15px",
                  color: "white",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  onOpenHandel();
                }}
              >
                All Quotes Share
              </button>
            </Box>
          </Box>
          {allData?.map((bank, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <QutationCard
                name={bank.name}
                logo={bank.logo}
                idvRange={bank.idvRange}
                premium={bank.premium}
                price={bank.price}
                priceColor={bank.priceColor}
                addons={bank.addons}
                idvValue={idvValue}
                addonsValue={addonsValue}
                setAddonsValue={setAddonsValue}
                downloadPDF={downloadPDF}
                qutation={true}
              />
            </Box>
          ))}
        </Grid2>
      </Grid2>
      <ShareCard open={open} onCloseHandel={onCloseHandel} />
      <div
        style={{
          position: "fixed",
          width: 0,
          height: 0,
          overflow: "hidden",
          pointerEvents: "none",
          opacity: 0,
        }}
      >
        <RenewBuyPDF pdfRef={pdfRef} downloadPDF={downloadPDF} />
      </div>
    </DashboardLayout>
  );
};

export default PlanProposalFlow;
